var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sso container"},[_c('h1',{staticClass:"mt-5 mb-5",domProps:{"innerHTML":_vm._s(_vm.headerMsg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }